import { defineComponent as _defineComponent } from 'vue'

export enum AuthLoginThirdPartyGroupButtonsType {
  Continue = 'Continue',
  LogIn = 'Log in',
  SignUp = 'Sign up',
}

import device from '@@/bits/device'
import fetchElectronBridge, { URLTarget } from '@@/bits/electron_bridge'
import { __ } from '@@/bits/intl'
import { getSearchParams, navigateTo, transformUrl } from '@@/bits/location'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import AuthLoginThirdPartyButton from '@@/vuecomponents/AuthLoginThirdPartyButton.vue'
import type { LoginMethod } from '@@/vuexstore/landside'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLoginThirdPartyGroupButtons',
  props: {
    loginMethods: { default: () => ({}) },
    type: { default: AuthLoginThirdPartyGroupButtonsType.Continue }
  },
  setup(__props: any) {

const props = __props as { loginMethods: Record<string, LoginMethod>, type: AuthLoginThirdPartyGroupButtonsType }



const { isDarkMode } = storeToRefs(useDarkModeStore())

const isApple = device.mac || device.ios

const appleText = computed<string>(() => {
  return {
    [AuthLoginThirdPartyGroupButtonsType.Continue]: __('Continue with Apple'),
    [AuthLoginThirdPartyGroupButtonsType.LogIn]: __('Log in with Apple'),
    [AuthLoginThirdPartyGroupButtonsType.SignUp]: __('Sign up with Apple'),
  }[props.type]
})

const googleText = computed<string>(() => {
  return {
    [AuthLoginThirdPartyGroupButtonsType.Continue]: __('Continue with Google'),
    [AuthLoginThirdPartyGroupButtonsType.LogIn]: __('Log in with Google'),
    [AuthLoginThirdPartyGroupButtonsType.SignUp]: __('Sign up with Google'),
  }[props.type]
})

const microsoftText = computed<string>(() => {
  return {
    [AuthLoginThirdPartyGroupButtonsType.Continue]: __('Continue with Microsoft'),
    [AuthLoginThirdPartyGroupButtonsType.LogIn]: __('Log in with Microsoft'),
    [AuthLoginThirdPartyGroupButtonsType.SignUp]: __('Sign up with Microsoft'),
  }[props.type]
})

const skoletubeText = computed<string>(() => {
  return {
    [AuthLoginThirdPartyGroupButtonsType.Continue]: __('Continue with Skoletube'),
    [AuthLoginThirdPartyGroupButtonsType.LogIn]: __('Log in with Skoletube'),
    [AuthLoginThirdPartyGroupButtonsType.SignUp]: __('Sign up with Skoletube'),
  }[props.type]
})

const classlinkText = computed<string>(() => {
  return {
    [AuthLoginThirdPartyGroupButtonsType.Continue]: __('Continue with ClassLink'),
    [AuthLoginThirdPartyGroupButtonsType.LogIn]: __('Log in with ClassLink'),
    [AuthLoginThirdPartyGroupButtonsType.SignUp]: __('Sign up with ClassLink'),
  }[props.type]
})

const cleverText = computed<string>(() => {
  return {
    [AuthLoginThirdPartyGroupButtonsType.Continue]: __('Continue with Clever'),
    [AuthLoginThirdPartyGroupButtonsType.LogIn]: __('Log in with Clever'),
    [AuthLoginThirdPartyGroupButtonsType.SignUp]: __('Sign up with Clever'),
  }[props.type]
})

const handleClick = (url: string | undefined): void => {
  if (!url) return
  const electronApp = fetchElectronBridge()
  const referralCode = getSearchParams().referral_code
  const oauthUrl = referralCode
    ? transformUrl(url, {
        searchParams: {
          referralCode,
        },
      })
    : url

  if (electronApp.openThirdPartyAuth) {
    return electronApp.openThirdPartyAuth(oauthUrl, URLTarget.Internal)
  }

  navigateTo(oauthUrl)
}

return { __sfc: true,AuthLoginThirdPartyGroupButtonsType, props, isDarkMode, isApple, appleText, googleText, microsoftText, skoletubeText, classlinkText, cleverText, handleClick, AuthLoginThirdPartyButton }
}

})